'use client';
/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Button } from '@quadminds/mindkit';
import type { ViewType } from '@quadminds/mindy-app/types/File/File.types';
import { Grid, Table2 } from 'lucide-react';

interface ViewToggleProps {
    currentView: ViewType;
    onViewChange: (view: ViewType) => void;
}

export function ViewToggle({ currentView, onViewChange }: ViewToggleProps) {
    return (
        <div className="flex items-center space-x-2" data-testid="view-toogles">
            <Button
                data-testid="grid-view"
                variant={currentView === 'grid' ? 'default' : 'ghost'}
                size="sm"
                onClick={() => onViewChange('grid')}
                aria-label="Grid view"
            >
                <Grid className="h-4 w-4" />
            </Button>
            <Button
                data-testid="table-view"
                variant={currentView === 'table' ? 'default' : 'ghost'}
                size="sm"
                onClick={() => onViewChange('table')}
                aria-label="Table view"
            >
                <Table2 className="h-4 w-4" />
            </Button>
        </div>
    );
}

export default ViewToggle;
